import React, { useCallback, useEffect } from 'react';
import { UserFileShowView, UserFileToken } from '../../../types/uploadedFiles';
import { useRemoteResource } from '../../../../commonv3/hooks/useRemoteResource';
import { UserFilesApi } from '../../../apis/userFiles';
import { SimpleUploadedFileSummary } from './SimpleUploadedFileSummary';
import { LoaderRow } from '../../atoms/layout/LoaderRow';
import { observer } from 'mobx-react';
import { TransitionGroup } from 'react-transition-group';
import { Fade } from '@material-ui/core';

type Props = {
  value: UserFileToken[];
};

export const UploadedFilePreview = observer(({ value }: Props) => {
  const loadTokens = useCallback(() => {
    return Promise.all(value ? value.map((token) => UserFilesApi.show(token)) : []);
  }, [value]);
  const [files, reload] = useRemoteResource<UserFileShowView[]>(loadTokens);
  useEffect(() => {
    reload();
  }, [value]);
  return (
    <div data-value="file-preview">
      <TransitionGroup>
        {files.getOrElse([]).map((file) => (
          <Fade key={file.token}>
            <SimpleUploadedFileSummary file={file} />
          </Fade>
        ))}
      </TransitionGroup>
      {files.loading && <LoaderRow />}
    </div>
  );
});
